import { Component, Inject, HostListener, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
    selector: 'app-display-image',
    templateUrl: './display-image.component.html',
    styleUrls: ['./display-image.component.scss']
})

export class MaterialDisplayImageComponent implements OnInit {
    images =[];
    selectedImage;
    constructor(
        private dialogRef: MatDialogRef<MaterialDisplayImageComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.images = data.images;
        this.selectedImage = this.images.indexOf(data.selectedImage);
    }
    moveImage(i: number,event){
        if(this.selectedImage + i > this.images.length-1){
            this.selectedImage = 0;
        }
        else if(this.selectedImage + i < 0){
            this.selectedImage = this.images.length - 1;
        }
        else{
            this.selectedImage = this.selectedImage + i;
        }
        this.stopePropagation(event);
    }
    stopePropagation(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    ngOnInit() {
    }

    activate() {
        this.dialogRef.close(true);
    }

    close() {
        this.dialogRef.close(false);
    }

    @HostListener('window:keyup.esc') onKeyUp() {
        this.dialogRef.close(false);
    }
}
